<template>
  <div class="col-md-12">
    <div class="card card-container">
      <Form @submit="login" :validation-schema="schema">
        <div class="form-group">
          <label for="username" class="form-text">Логин</label>
          <Field
            name="username"
            type="text"
            class="form-control"
            autocomplete="false"
          />
          <ErrorMessage name="username" class="error-feedback" />
        </div>
        <div class="form-group">
          <label for="password" class="form-text">Пароль</label>
          <Field name="password" type="password" class="form-control" />
          <ErrorMessage name="password" class="error-feedback" />
        </div>

        <div class="form-group__btn form-group">
          <Button type="submit" label="Войти" :loading="isLoading" />
        </div>
        <div class="form-group">
          <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
          </div>
        </div>
      </Form>
      <a
        class="form-group__recover"
        href="https://avia.biletdv.ru/Login/ctl/SendPassword?returnurl=https://avia.biletdv.ru/Login"
        >Забыли пароль?</a
      >
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "@vue/runtime-core";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import store from "../store/index";

import { mapActions, mapGetters, mapMutations } from "vuex";
import Button from "primevue/button";

export default defineComponent({
  name: "Login",
  components: {
    Form,
    Field,
    ErrorMessage,
    Button,
  },
  data() {
    const schema = yup.object().shape({
      username: yup.string().required("Введите логин!"),
      password: yup.string().required("Введите пароль!"),
    });

    return {
      isLoading: false,
      message: "",
      schema,
    };
  },
  computed: {
    ...mapGetters("auth", {
      getterLoginStatus: "getLoginStatus",
    }),
  },
  methods: {
    ...mapActions("auth", {
      actionLogin: "login",
    }),
    async login(user: any) {
      this.isLoading = true;
      await this.actionLogin(user);
      if (this.getterLoginStatus === "success") {
        this.$router.push("/orders");
      } else {
        this.isLoading = false;
        this.message = "Логин или пароль неверны!";
      }
    },
  },
});
</script>
<style lang="scss">
.col-md-12 {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.form-group {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.card-container {
  margin-top: 50px;
  padding: 30px;
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.form-text {
  margin-top: 5px;
  // margin-left: 0;
  // margin-right: auto;
  font-size: 14px;
  font-weight: bold;
  color: #706e6e;
}

form .form-group:nth-child(2) {
  margin-top: 10px;
}

.form-control {
  margin-top: 5px;
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 3px;
}

.form-control:focus {
  outline: none !important;
  border-radius: 3px;
  box-shadow: 0 0 0 0.2em #bbdefb;
  border: 1px solid #2196f3 !important;
}

.form-control:hover {
  border: 1px solid #2196f3;
}

.error-feedback {
  color: rgb(167, 46, 46);
}

.form-group__btn {
  margin-top: 25px;
}

.alert-danger {
  margin-top: 10px;
  font-size: 14px;
  font-weight: bold;
  color: red;
}

.form-group__recover {
  display: block;
  text-align: center;
  margin-top: 15px;
  font-size: 14px;
  cursor: pointer;
  color: #2196f3;
}

@media screen and (max-width: 767px) {
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .form-text {
    font-size: 16px;
  }
}

@media screen and (min-width: 1025px) {
  .form-text {
    font-size: 16px;
  }
}
</style>
